// src/lib/data/plans.ts
export const plans = [
  {
    title: "The Royal Chronograph Reveal",
    desc: "An exclusive first look at the 2026 Grand Complication series, featuring hand-finished movements and sapphire casing.",
    author: "Master Curator",
    date: "2026.06.15",
    location: "Haeundae Luxury Gallery",
    img: "/img/event1.jpg", // <--- JPEG extension
  },
  {
    title: "Vintage Rolex Retrospective",
    desc: "A curated journey through the 20th century's most iconic sports watches and their historical significance.",
    author: "Heritage Specialist",
    date: "2026.07.20",
    location: "Busan Marina Club",
    img: "/img/event2.jpg", // <--- JPEG extension
  },
  {
    title: "Precision & Artistry Workshop",
    desc: "Join our master watchmakers for a live demonstration of hairspring adjustment and dial enameling.",
    author: "Technical Director",
    date: "2026.08.05",
    location: "Main Boutique Studio",
    img: "/img/event3.jpg", // <--- JPEG extension
  },
  {
    title: "Midnight Auction Gala",
    desc: "Bidding opens for rare, limited-edition timepieces. A black-tie evening for the world's most serious collectors.",
    author: "Lead Auctioneer",
    date: "2026.12.31",
    location: "Grand Hyatt Ballroom",
    img: "/img/event4.jpg", // <--- JPEG extension
  },
];